/**
 * @generated SignedSource<<59673ea43af60bd1810fea556304e8e8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type CartChannel = "businessshop" | "personalshop" | "personalss" | "sparkdigitalshop";
export type IneligibleAccountReason = "ACCOUNT_LIMIT_REACHED" | "ALL_LINES_INELIGIBLE" | "INCOMPATIBLE_PLAN" | "INVALID_SEGMENT" | "UNSATISFIED_DEPENDENCY";
export type IneligibleLineReason = "CART_THRESHOLD_REACHED" | "INCOMPATIBLE_PLAN" | "INVALID_SEGMENT" | "LINE_LIMIT_REACHED" | "PREPAID_LINE" | "UNSATISFIED_DEPENDENCY";
export type ChangePlanParentPlanSelectionContentQuery$variables = {
  channel: CartChannel;
  lineNumber: string;
  offerId: string;
  sourceOfferId: string;
};
export type ChangePlanParentPlanSelectionContentQuery$data = {
  readonly changePlanEligibility: {
    readonly eligibleAccounts: ReadonlyArray<{
      readonly accountName: string | null;
      readonly accountNumber: string;
      readonly eligibilityCountAvailable: number | null;
      readonly eligibilityCountMaximum: number | null;
      readonly eligibleLines: ReadonlyArray<{
        readonly lineNumber: string;
        readonly offerId: string;
        readonly offerName: string;
      }>;
      readonly ineligibleLines: ReadonlyArray<{
        readonly lineNumber: string;
        readonly offerId: string;
        readonly offerName: string;
        readonly reason: IneligibleLineReason | null;
      }>;
    }>;
    readonly ineligibleAccounts: ReadonlyArray<{
      readonly accountName: string | null;
      readonly accountNumber: string;
      readonly eligibilityCountAvailable: number | null;
      readonly eligibilityCountMaximum: number | null;
      readonly reason: IneligibleAccountReason | null;
    }>;
  };
};
export type ChangePlanParentPlanSelectionContentQuery = {
  response: ChangePlanParentPlanSelectionContentQuery$data;
  variables: ChangePlanParentPlanSelectionContentQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "channel"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "lineNumber"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "offerId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sourceOfferId"
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "accountNumber",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "accountName",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "eligibilityCountAvailable",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "eligibilityCountMaximum",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lineNumber",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "offerId",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "offerName",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "reason",
  "storageKey": null
},
v12 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "channel",
            "variableName": "channel"
          },
          {
            "kind": "Variable",
            "name": "lineNumber",
            "variableName": "lineNumber"
          },
          {
            "kind": "Variable",
            "name": "offerId",
            "variableName": "offerId"
          },
          {
            "kind": "Variable",
            "name": "sourceOfferId",
            "variableName": "sourceOfferId"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "ChangePlanEligibilityResponse",
    "kind": "LinkedField",
    "name": "changePlanEligibility",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "EligibleAccountDetails",
        "kind": "LinkedField",
        "name": "eligibleAccounts",
        "plural": true,
        "selections": [
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "EligibleLineDetails",
            "kind": "LinkedField",
            "name": "eligibleLines",
            "plural": true,
            "selections": [
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "IneligibleLineDetails",
            "kind": "LinkedField",
            "name": "ineligibleLines",
            "plural": true,
            "selections": [
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "IneligibleAccountDetails",
        "kind": "LinkedField",
        "name": "ineligibleAccounts",
        "plural": true,
        "selections": [
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v11/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ChangePlanParentPlanSelectionContentQuery",
    "selections": (v12/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v3/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "ChangePlanParentPlanSelectionContentQuery",
    "selections": (v12/*: any*/)
  },
  "params": {
    "cacheID": "1d5e9760bd151f8801a34d78ecde6763",
    "id": null,
    "metadata": {},
    "name": "ChangePlanParentPlanSelectionContentQuery",
    "operationKind": "query",
    "text": "query ChangePlanParentPlanSelectionContentQuery(\n  $offerId: String!\n  $sourceOfferId: String!\n  $lineNumber: String!\n  $channel: CartChannel!\n) {\n  changePlanEligibility(input: {offerId: $offerId, sourceOfferId: $sourceOfferId, lineNumber: $lineNumber, channel: $channel}) {\n    eligibleAccounts {\n      accountNumber\n      accountName\n      eligibilityCountAvailable\n      eligibilityCountMaximum\n      eligibleLines {\n        lineNumber\n        offerId\n        offerName\n      }\n      ineligibleLines {\n        lineNumber\n        offerId\n        offerName\n        reason\n      }\n    }\n    ineligibleAccounts {\n      accountNumber\n      accountName\n      eligibilityCountAvailable\n      eligibilityCountMaximum\n      reason\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "f6b7ea0e6ae8ab8a213758f92bd48d56";

export default node;
